export interface PortfolioApp {
  name: string;
  category: string;
  platform: 'android' | 'ios' | 'both';
  storeUrl: string;
  secondaryStoreUrl?: string;
  description: string;
  icon?: string;
  stats?: string;
  technologies?: string[];
}

export interface ComplianceBadge {
  name: string;
  shortName: string;
  description: string;
}

export const complianceBadges: ComplianceBadge[] = [
  {
    name: "HIPAA Compliant",
    shortName: "HIPAA",
    description: "Health Insurance Portability and Accountability Act"
  },
  {
    name: "GDPR Compliant",
    shortName: "GDPR",
    description: "General Data Protection Regulation"
  },
  {
    name: "SOC 2 Compliant",
    shortName: "SOC 2",
    description: "Service Organization Control Type 2"
  },
  {
    name: "FDA Compliant",
    shortName: "FDA",
    description: "Food and Drug Administration"
  },
  {
    name: "HITRUST Certified",
    shortName: "HITRUST",
    description: "Health Information Trust Alliance"
  },
  {
    name: "ISO 27001",
    shortName: "ISO",
    description: "Information Security Management"
  }
];

export const mobileApps: PortfolioApp[] = [
  {
    name: "Mammography Assistant",
    category: "Healthcare",
    platform: "both",
    storeUrl: "https://play.google.com/store/apps/details?id=thebrewapps.mammographyassistant",
    secondaryStoreUrl: "https://apps.apple.com/in/app/mammography-assistant/id1534082005",
    description: "Professional radiology education with interactive modules",
    technologies: ["iOS (Swift/SwiftUI)", "Android (Kotlin)", "Medical Imaging Processing", "Cloud Storage"]
  },
  {
    name: "nudge",
    category: "Business Tools",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/nudge-digital-business-card/id1550508139",
    description: "NFC-enabled digital business card for instant sharing",
    technologies: ["React Native", "NFC Technology", "QR Code Generation", "Cloud Database"]
  },
  {
    name: "OwnersProof",
    category: "Lifestyle",
    platform: "both",
    storeUrl: "https://play.google.com/store/apps/details?id=com.ownersproof.ownersproof",
    secondaryStoreUrl: "https://apps.apple.com/in/app/ownersproof/id6738924140",
    description: "Smart asset cataloging with OCR and insurance tools",
    technologies: ["Flutter", "Claude AI", "Firebase Storage", "AWS S3", "Google Vision API", "Node.js"]
  },
  {
    name: "JunoMarkets",
    category: "Finance & Crypto",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/junomarkets-juno-auto-trader/id1533197831",
    description: "Auto-trading platform with real-time market analysis",
    technologies: ["Swift", "SwiftUI", "Firebase Authentication", "AWS HealthLake", "Node.js", "Express"]
  },
  {
    name: "EZTape",
    category: "Business Tools",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/record-phone-calls-eztape/id1512476140",
    description: "AI call recorder with transcription in 100+ languages",
    technologies: ["iOS (Swift)", "OpenAI Whisper API", "ChatGPT API", "Firebase Storage", "AWS S3"]
  },
  {
    name: "PandoraBiz",
    category: "Finance & Shopping",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.devherds.pandorabiz&hl=en",
    description: "E-commerce app with payment integration and digital content",
    stats: "10K+ Downloads"
  },
  {
    name: "One Point",
    category: "Fitness & Sports",
    platform: "both",
    storeUrl: "https://play.google.com/store/apps/details?id=com.onepointtechnologies.app",
    secondaryStoreUrl: "https://apps.apple.com/us/app/one-point-players-on-demand/id6736460451",
    description: "Sports networking platform for athletes",
    stats: "1K+ Downloads"
  },
  {
    name: "STAG",
    category: "Business & Networking",
    platform: "ios",
    storeUrl: "https://apps.apple.com/in/app/stag-digital-business-card/id6448947007",
    description: "NFC digital business card app",
    stats: "New App"
  },
  {
    name: "Plan & Work",
    category: "Business & Productivity",
    platform: "both",
    storeUrl: "https://play.google.com/store/apps/details?id=net.planandwork.app",
    secondaryStoreUrl: "https://apps.apple.com/us/app/plan-and-work/id1641062448",
    description: "Workforce management and shift planning",
    stats: "1K+ Downloads"
  },
  {
    name: "Ghasla",
    category: "On-Demand Services",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.app_ghasla",
    description: "Car wash and cleaning services app"
  },
  {
    name: "BlazePod",
    category: "Fitness & Sports",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=co.blazepod.blazepod&hl=en-IN",
    description: "Flash reflex training system for athletes"
  },
  {
    name: "Galileo Offline Maps",
    category: "Navigation",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.bodunov.galileo&hl=en",
    description: "Offline GPS navigation and maps"
  },
  {
    name: "Lone Star Hazmat",
    category: "Industrial",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.lonestarhazmatapp.app",
    description: "Hazmat safety compliance application"
  },
  {
    name: "British Museum Guide",
    category: "Travel & Tourism",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/audio-guide-british-museum/id551275212",
    description: "Audio guide for British Museum visitors"
  },
  {
    name: "ShowMyParking",
    category: "Parking & Transport",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.showmyparking",
    description: "Smart parking finder application"
  },
  {
    name: "MoveSpot",
    category: "Fitness",
    platform: "ios",
    storeUrl: "https://apps.apple.com/in/app/movespot/id1538695830",
    description: "Fitness and movement tracking"
  },
  {
    name: "AMDA Parking",
    category: "Parking & Transport",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.smp.amda_parking",
    description: "Airport parking management system"
  },
  {
    name: "MyMood AI",
    category: "Health & Wellness",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=app.mymoodai",
    description: "AI-powered mood tracking and wellness"
  },
  {
    name: "GreenPal",
    category: "On-Demand Services",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.ionicframework.greenpal793748&hl=en&gl=US",
    description: "Lawn care and landscaping marketplace"
  },
  {
    name: "Eatigo",
    category: "Food & Dining",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/eatigo/id879030389",
    description: "Restaurant reservation with discounts"
  },
  {
    name: "SwingTweaks",
    category: "Sports",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/swingtweaks/id1612839087",
    description: "Golf swing analysis application"
  },
  {
    name: "Kids Maths Game",
    category: "Education",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.kidsmathsgame.mathematicalpuzzles",
    description: "Educational math puzzles for children"
  },
  {
    name: "SunCrypto",
    category: "Finance & Crypto",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.suncrypto.in",
    description: "Cryptocurrency trading platform"
  },
  {
    name: "Healthmug",
    category: "Healthcare",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.healthmug",
    description: "Online pharmacy and healthcare"
  },
  {
    name: "DailyBreath",
    category: "Health & Wellness",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.dailybreath",
    description: "Breathing exercises and meditation"
  },
  {
    name: "Safe365",
    category: "Safety",
    platform: "ios",
    storeUrl: "https://apps.apple.com/in/app/safe365/id1445087524",
    description: "Family safety and location tracking"
  },
  {
    name: "Mobile Cover Photo Editor",
    category: "Photo & Video",
    platform: "android",
    storeUrl: "https://play.google.com/store/apps/details?id=com.mobile.cover.photo.editor.back.maker&hl=en-IN",
    description: "Custom phone case design tool"
  },
  {
    name: "CheckIn360",
    category: "Business",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/checkin360/id1233634684",
    description: "Employee check-in and attendance"
  },
  {
    name: "LoveMySkool",
    category: "Education",
    platform: "ios",
    storeUrl: "https://apps.apple.com/in/app/lovemyskool/id1138805934",
    description: "School management and parent portal"
  },
  {
    name: "Fanoss",
    category: "Entertainment",
    platform: "ios",
    storeUrl: "https://apps.apple.com/us/app/fanoss-%D9%81%D8%A7%D9%86%D9%88%D8%B3/id1156356977",
    description: "Middle Eastern entertainment platform"
  },
  {
    name: "BizConnect",
    category: "On-Demand Services",
    platform: "ios",
    storeUrl: "https://apps.apple.com/nz/app/bizconnect-ltd/id6756949643",
    description: "On-demand marketplace connecting New Zealand clients with 37+ categories of local service providers — plumbing, electrical, cleaning, photography and more",
    stats: "5.0 ★ Rating",
    technologies: ["Flutter", "Firebase", "Node.js", "Google Maps API", "Real-Time Messaging", "Push Notifications"]
  },
  {
    name: "MyPathos",
    category: "Health & Wellness",
    platform: "both",
    storeUrl: "https://play.google.com/store/apps/details?id=org.pathos.faith",
    secondaryStoreUrl: "https://apps.apple.com/us/app/mypathos/id6761451505",
    description: "Faith-based daily habit tracker with prayer, journaling, devotionals, and community groups",
    technologies: ["React Native", "Firebase", "Push Notifications", "Community Feeds"]
  }
];

export const appCategories = [
  "All",
  "Business & Networking",
  "Business & Productivity",
  "Finance & Shopping",
  "Healthcare",
  "Fitness & Sports",
  "Business Tools",
  "Lifestyle",
  "On-Demand Services",
  "Finance & Crypto",
  "Education",
  "Travel & Tourism",
  "Parking & Transport",
  "Health & Wellness"
];

export interface UpworkProject {
  title: string;
  budget: string;
  duration: string;
  industry: string;
  description: string;
  whoItServes: string;
  whatItDelivers: string;
  technologies: string[];
  type: 'Web App' | 'Mobile App' | 'AI/ML' | 'Full Stack';
}

export const upworkProjects: UpworkProject[] = [
  {
    title: "Ortem Health",
    budget: "$50,001 - $100,000",
    duration: "Ongoing",
    industry: "Healthcare & Medical",
    description: "A healthcare technology platform built to help hospitals, clinics, and diagnostic centers digitize care delivery, streamline operations, and enhance patient experience. It focuses on AI-driven workflows, real-time data, and secure, cloud-native infrastructure.",
    whoItServes: "Hospitals, multi-speciality clinics, and diagnostic chains looking to modernize clinical and administrative workflows with a single integrated platform.",
    whatItDelivers: "End-to-end healthcare software solutions: EMR/EHR modules, patient engagement tools, appointment and billing management, and analytics tailored to provider workflows.",
    technologies: ["React", "Node.js", "PostgreSQL", "AWS", "HIPAA Compliant"],
    type: "Full Stack"
  },
  {
    title: "AI-Powered Document Analysis",
    budget: "$25,001 - $50,000",
    duration: "4 months",
    industry: "Legal Tech",
    description: "Intelligent document processing system using GPT-4 and custom ML models for contract analysis, risk assessment, and automated data extraction from legal documents.",
    whoItServes: "Law firms, corporate legal departments, and compliance teams needing to process large volumes of contracts and legal documents efficiently.",
    whatItDelivers: "AI-assisted contract review, clause extraction, risk scoring, and automated compliance checking with 95%+ accuracy.",
    technologies: ["Python", "OpenAI", "LangChain", "FastAPI", "AWS"],
    type: "AI/ML"
  },
  {
    title: "Enterprise Fleet Management",
    budget: "$75,001 - $150,000",
    duration: "8 months",
    industry: "Logistics & Transportation",
    description: "Comprehensive fleet tracking and management platform with real-time GPS tracking, driver behavior analytics, fuel management, and predictive maintenance.",
    whoItServes: "Logistics companies, delivery services, and enterprises managing large vehicle fleets across multiple locations.",
    whatItDelivers: "Real-time fleet visibility, route optimization, compliance reporting, and cost reduction through data-driven insights.",
    technologies: ["React Native", "Node.js", "MongoDB", "IoT", "Google Maps API"],
    type: "Mobile App"
  },
  {
    title: "FinTech Investment Platform",
    budget: "$100,001 - $200,000",
    duration: "12 months",
    industry: "Finance & Banking",
    description: "A comprehensive investment and wealth management platform with robo-advisory features, portfolio management, and real-time market data integration.",
    whoItServes: "Retail investors, financial advisors, and wealth management firms seeking modern digital investment solutions.",
    whatItDelivers: "Automated portfolio rebalancing, risk assessment tools, tax-loss harvesting, and detailed performance analytics.",
    technologies: ["React", "Python", "PostgreSQL", "Redis", "Plaid API"],
    type: "Web App"
  }
];

export const trustIndicators = {
  projectsCompleted: "1,000+",
  clientSatisfaction: "98%",
  countriesServed: "50+",
  yearsExperience: "13+",
  upworkSuccessRate: "100%",
  repeatClients: "85%"
};

export interface WebApp {
  name: string;
  category: string;
  url: string;
  description: string;
  iconInitial: string; // For the circular badge
  technologies: string[];
  badgeColor?: string; // Optional hint for gradients
  hideVisitCta?: boolean; // Suppress "Visit Site" CTA for pre-launch/NDA engagements
}

export const webAppCategories = [
  "All",
  "FinTech",
  "AI & Productivity",
  "E-commerce",
  "SaaS",
  "Legal Tech",
  "Education",
  "Entertainment",
  "On-Demand Services",
  "Healthcare"
];

export const webApps: WebApp[] = [
  {
    name: "DreamZzz",
    category: "AI & Productivity",
    url: "https://dreamzzz.ai/",
    description: "AI-powered dream journal with emotional insights and pattern recognition",
    iconInitial: "D",
    technologies: ["React", "Next.js", "AI Development", "Full-Stack"],
    badgeColor: "Purple"
  },
  {
    name: "TreasuryMap",
    category: "Finance & FinTech",
    url: "https://treasurymap.com/",
    description: "European treasury industry information hub with interactive map interface",
    iconInitial: "T",
    technologies: ["React", "Web Development", "UX/UI", "SEO"],
    badgeColor: "Green"
  },
  {
    name: "Biotanik",
    category: "E-commerce",
    url: "https://biotanik.com.ec/",
    description: "High-performance e-commerce platform for hair products with advanced SEO",
    iconInitial: "B",
    technologies: ["Web Development", "SEO Strategy", "UX/UI Design"],
    badgeColor: "Orange"
  },
  {
    name: "Carzilla Motors",
    category: "FinTech & Investment",
    url: "https://investments.carzillamotors.com/",
    description: "Luxury car investment platform with vehicle share trading and portfolio tracking",
    iconInitial: "C",
    technologies: ["Next.js", "TypeScript", "Tailwind CSS", "Stripe API"],
    badgeColor: "Green"
  },
  {
    name: "Portugal Visa Navigator",
    category: "SaaS & Legal Tech",
    url: "https://ptvisanavigator.com/",
    description: "Visa eligibility assessment tool for Portuguese residence applications",
    iconInitial: "P",
    technologies: ["Next.js", "Supabase", "Stripe", "API Integration"],
    badgeColor: "Blue"
  },
  {
    name: "Fitness SaaS Platform",
    category: "SaaS",
    url: "#",
    description: "All-in-one SaaS for trainers to launch branded apps and sell programs",
    iconInitial: "F",
    technologies: ["Python", "Django", "React", "AWS"],
    badgeColor: "Green"
  },
  {
    name: "DF Designs Jewelry",
    category: "E-commerce",
    url: "https://dfdesignsjewelry.com/",
    description: "Professional jewelry store specializing in custom design, repairs, and bridal jewelry expertise",
    iconInitial: "D",
    technologies: ["React", "Material UI", "Node.js"],
    badgeColor: "Purple"
  },
  {
    name: "Membership.io",
    category: "SaaS",
    url: "https://membership.io/",
    description: "AI-powered platform for creators to build, manage, and monetize membership sites and courses",
    iconInitial: "M",
    technologies: ["Next.js", "React", "AI Integration", "Tailwind CSS"],
    badgeColor: "Green"
  },
  {
    name: "Nimbus Editor",
    category: "SaaS",
    url: "https://nimbuseditor.com/",
    description: "No-code editor designed for web developers to accelerate frontend coding through visual editing",
    iconInitial: "N",
    technologies: ["React", "TypeScript", "Vite", "Styled Components"],
    badgeColor: "Blue"
  },
  {
    name: "Roobet",
    category: "Entertainment",
    url: "https://roobet.com/",
    description: "Leading crypto-first online casino offering proprietary games, slots, and seamless betting",
    iconInitial: "R",
    technologies: ["React", "Next.js", "Socket.io", "Web3"],
    badgeColor: "Orange"
  },
  {
    name: "Upgrade.chat",
    category: "FinTech",
    url: "https://upgrade.chat/",
    description: "Platform enabling Discord and Telegram communities to monetize through subscriptions",
    iconInitial: "U",
    technologies: ["React", "Node.js", "Stripe API", "Discord API"],
    badgeColor: "Blue"
  },
  {
    name: "BC.GAME",
    category: "Entertainment",
    url: "https://bcgame46.com/",
    description: "Award-winning crypto casino platform with versatile gaming and sports betting experience",
    iconInitial: "B",
    technologies: ["React", "Next.js", "Redux", "Web3"],
    badgeColor: "Green"
  },
  {
    name: "PrepSharp",
    category: "Education",
    url: "https://www.prepsharp.com/",
    description: "Tools and resources for tutors and students to grade practice tests and track ACT/SAT progress",
    iconInitial: "P",
    technologies: ["React", "Tailwind CSS", "Firebase"],
    badgeColor: "Blue"
  },
  {
    name: "FinanceThat",
    category: "FinTech",
    url: "https://financethat.ca/",
    description: "Canadian financing marketplace connecting buyers with lenders for vehicles and home improvements",
    iconInitial: "F",
    technologies: ["WordPress", "Elementor", "PHP", "MySQL"],
    badgeColor: "Orange"
  },
  {
    name: "BizConnect",
    category: "On-Demand Services",
    url: "https://www.bizconnectltd.com/",
    description: "Dual-sided on-demand services marketplace for New Zealand — connecting clients with 37+ categories of local professionals via district-first job matching, real-time messaging, and a 5.0-star rated iOS app",
    iconInitial: "B",
    technologies: ["Flutter", "Firebase", "Node.js", "Google Maps API", "Real-Time Messaging"],
    badgeColor: "Blue"
  },
  {
    name: "CivicHub",
    category: "SaaS",
    url: "/case-studies/civichub-nonprofit-community-platform",
    description: "Nonprofit GPO & community platform with unified SSO across community and business dashboards",
    iconInitial: "C",
    technologies: ["NestJS", "PostgreSQL RLS", "Auth0 + SAML SSO", "AWS CDK", "Next.js"],
    badgeColor: "Blue",
    hideVisitCta: true
  },
  {
    name: "NearDeal",
    category: "E-commerce",
    url: "/case-studies/neardeal-hyperlocal-deals-marketplace",
    description: "Location-based deals marketplace with real-time geofenced alerts for local businesses",
    iconInitial: "N",
    technologies: ["React Native", "PostGIS", "FCM / APNs", "Claude API", "Node.js"],
    badgeColor: "Orange",
    hideVisitCta: true
  },
  {
    name: "CareFlow AI",
    category: "Healthcare",
    url: "/case-studies/careflow-ai-clinic-management-platform",
    description: "AI-assisted clinic operating system with human-in-the-loop sign-off across every workflow",
    iconInitial: "C",
    technologies: ["Claude API", "WhatsApp Business API", "Android (native)", "Node.js", "PostgreSQL"],
    badgeColor: "Green",
    hideVisitCta: true
  }
];
